import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
@Pipe({
  name: 'linkify'
})
export class LinkifyPipe implements PipeTransform {
  urls: any = /(\b(https?|http|ftp|ftps|Https|rtsp|Rtsp):\/\/[A-Z0-9+&@#\/%?=~_|!:,.;-]*[-A-Z0-9+&@#\/%=~_|])/gim;
  hashtags: any = /(^|\s)(#[a-z\d][\w-]*)/ig; // Find/Replace #hashtags in text
  mentions: any = /(^|\s)(@[a-z\d][\w-]*)/ig; // Find/Replace @Handle/Mentions in text
  emails: any = /(\S+@\S+\.\S+)/gim; // Find/Replace email addresses in text

  constructor(private domSanitizer: DomSanitizer) { }

  // transform(value: any, args?: any): any {
  //   return this.domSanitizer.bypassSecurityTrustHtml(this.stylize(value));
  // }

  // private stylize(text: string): string {
  //   let stylizedText: any = '';
  //   if (text && text.length > 0) {
  //     for (const t of text.split(' ')) {
  //       if ((t.startsWith('https') || t.startsWith('www') || t.startsWith('http')) && t.length > 1) {
  //         stylizedText += `<a href="#${t.substring(1)}">${t}</a> `;
  //       } else {
  //         stylizedText += t + ' ';
  //       }
  //     }
  //     return stylizedText;
  //   } else { return text; }
  // }


  transform(link: string): string {
    return this.linkify(link);
  }

  private linkify(plainText): string {
    let replacedText;
    let replacePattern1;
    let replacePattern2;
    let replacePattern3;

    // URLs starting with http://, https://, or ftp://
    replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
    replacedText = plainText.replace(replacePattern1, '<a href="$1" target="_blank">$1</a>');

    // URLs starting with "www." (without // before it, or it'd re-link the ones done above).
    replacePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
    replacedText = replacedText.replace(replacePattern2, '$1<a href="http://$2" target="_blank">$2</a>');

    // Change email addresses to mailto:: links.
    replacePattern3 = /(([a-zA-Z0-9\-\_\.])+@[a-zA-Z\_]+?(\.[a-zA-Z]{2,6})+)/gim;
    replacedText = replacedText.replace(replacePattern3, '<a href="mailto:$1">$1</a>');

    return replacedText;
  }


  // transform(text: string) {
  //   return this.parseUrl(text);
  // }

  // private parseUrl(text: string) {
  //   // Find/Replace URL's in text
  //   if (text.match(this.urls)) {
  //     text = text.replace(this.urls, function replacer($1, $2, $3) {
  //       const url: any = $1;
  //       const urlClean: any = url.replace("" + $3 + "://", "");

  //       return "<a href=\"" + url + "\" target=\"_blank\">" + urlClean + "</a>";
  //     });
  //   }

  //   // Find/Replace @Handle/Mentions in text
  //   if (text.match(this.hashtags)) {
  //     text = text.replace(this.hashtags, "<a href=\"/search/hashtag/$2\" class=\"hashtag-link\">$1$2</a>");
  //   }

  //   // Find/Replace #hashtags in text
  //   if (text.match(this.mentions)) {
  //     text = text.replace(this.mentions, "<a href=\"/search/handle/$2\" class=\"handle-link\">$1$2</a>");
  //   }

  //   // Find/Replace email addresses in text
  //   if (text.match(this.emails)) {
  //     text = text.replace(this.emails, "<a href=\"mailto:$1\">$1</a>");
  //   }

  //   return text;
  // }

}
